/**
 * Ports `RemoteTransform2D::get_configuration_warnings()` (remote_transform_2d.cpp:213-220):
 * one warning for `remote_path` absent, naming no node, or naming a non-Node2D.
 * An absent path is the empty `NodePath()`, and `has_node()` on it is false, so
 * absence is the trigger. `resolveNodePath` declines only a walk into another file.
 * A second arm warns on a relay in a relay cycle (`relayCycles.ts`).
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
import { extractNodePath } from '../../../linter/linterUtils.js';
import { resolveNodePath } from '../../../linter/nodePathResolve.js';
import { descendsFromClass } from '../../../godot/classdb/classBaseTypes.js';
import { relayCycleArm, relayCycleDiagnostics } from '../../shared/remotetransform/relayCycles.js';
const arms = {
    invalidRemotePath: groundedArm('remotetransform2d-invalid-remote-path', { kind: 'configuration-warning' }),
    relayCycle: relayCycleArm('remotetransform2d-relay-cycle', 'remote_transform_2d.cpp:127-136'),
};
function warn(node, detail) {
    return [
        armDiagnostic(arms.invalidRemotePath, node, `RemoteTransform2D '${node.name}' ${detail} Path property must point to a valid Node2D node to work.`),
    ];
}
function checkRemoteTransform2D(context) {
    const { node, scene } = context;
    const raw = node.rawProperties.remote_path;
    const path = raw !== undefined ? extractNodePath(raw) : null;
    if (path === null) {
        return warn(node, 'has no remote_path set.');
    }
    const target = resolveNodePath(scene, node, path);
    if (target.status === 'missing') {
        return warn(node, `has remote_path set to NodePath("${path}"), which names no node in this file.`);
    }
    if (target.status === 'found' && target.node.type && !descendsFromClass(target.node.type, 'Node2D')) {
        return warn(node, `has remote_path pointing to '${target.node.name}', a ${target.node.type}, which is not a Node2D.`);
    }
    return [];
}
const remoteTransform2DPathRule = {
    meta: {
        name: 'valid-remotetransform2d-remote-path',
        description: 'Warns when RemoteTransform2D has no remote_path, or remote_path resolves to no node or a non-Node2D node, and on a relay in a relay cycle',
        category: 'validation',
        applicableNodeTypes: ['RemoteTransform2D'],
        emits: armEmits(arms),
    },
    check: (context) => [
        ...checkRemoteTransform2D(context),
        ...relayCycleDiagnostics(arms.relayCycle, context),
    ],
};
ruleRegistry.register(remoteTransform2DPathRule);
//# sourceMappingURL=linter.js.map